import { render, staticRenderFns } from "./MarineLogo.vue?vue&type=template&id=f8bf62ca&"
import script from "./MarineLogo.vue?vue&type=script&lang=js&"
export * from "./MarineLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports